module.exports = __webpack_public_path__ + "static/media/photo_13.5c10e1e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_13.jpg
// module id = 1646
// module chunks = 0